export async function getLobbyGameData({ token, userId, themeName, lobby_name, lobby_pin }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/getLobbyGameData`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      ...(themeName != null && String(themeName).trim() !== "" ? { themeName } : {}),
      lobby_name,
      ...(lobby_pin != null && String(lobby_pin).trim() !== "" ? { lobby_pin } : {}),
    }),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data.message || "Failed to load game data");
  if (data && data.success === false) throw new Error(data.message || "Failed to load game data");
  return data;
}

